import { createApp } from 'vue'
import App from '@/core/app.vue'
import { initializeInstallers } from '@/core/config'

import '@/shared/assets/styles/main.css'

async function bootstrapApplication() {
  try {
    const app = createApp(App)

    await initializeInstallers(app)

    app.mount('#app')
  }
  catch (error) {
    console.error('Application initialization failed:', error)
  }
}

bootstrapApplication()

if (import.meta.hot) {
  import.meta.hot.accept()
}
